// Structured list of essential medicines by system/disease category.
// Each entry has: category, name, adultDose, pediatricDose, notes.
// This list is not exhaustive but covers common conditions encountered in primary care.

const medicineList = [
  // Respiratory system (Asthma/COPD and infections)
  {
    category: 'Respiratory',
    name: 'Salbutamol inhaler 100 mcg',
    adultDose: '2 puffs PRN',
    pediatricDose: '1 puff PRN',
    notes: 'Short‑acting bronchodilator for relief of wheeze',
  },
  {
    category: 'Respiratory',
    name: 'Levosalbutamol inhaler 50 mcg',
    adultDose: '2 puffs PRN',
    pediatricDose: '1 puff PRN',
    notes: 'Alternative SABA with fewer side effects',
  },
  {
    category: 'Respiratory',
    name: 'Budesonide/Formoterol 200/6 mcg inhaler',
    adultDose: '1 puff BD',
    pediatricDose: 'Consult specialist',
    notes: 'ICS/LABA combination for persistent asthma or COPD',
  },
  {
    category: 'Respiratory',
    name: 'Ipratropium inhaler 40 mcg',
    adultDose: '2 puffs QID',
    pediatricDose: '1 puff QID',
    notes: 'Anticholinergic bronchodilator',
  },
  {
    category: 'Respiratory',
    name: 'Prednisolone 10 mg tablet',
    adultDose: '10–40 mg PO OD',
    pediatricDose: '1 mg/kg/day',
    notes: 'Short course for acute exacerbation',
  },
  {
    category: 'Respiratory',
    name: 'Montelukast 10 mg tablet',
    adultDose: '10 mg PO OD',
    pediatricDose: '4–5 mg PO OD',
    notes: 'Leukotriene receptor antagonist',
  },

  // Gastrointestinal system
  {
    category: 'Gastrointestinal',
    name: 'Omeprazole 20 mg capsule',
    adultDose: '20 mg PO OD',
    pediatricDose: '0.7 mg/kg PO OD',
    notes: 'Proton pump inhibitor',
  },
  {
    category: 'Gastrointestinal',
    name: 'Pantoprazole 40 mg tablet',
    adultDose: '40 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Proton pump inhibitor',
  },
  {
    category: 'Gastrointestinal',
    name: 'Ranitidine 150 mg tablet',
    adultDose: '150 mg PO BD',
    pediatricDose: '2 mg/kg PO BD',
    notes: 'H2 receptor blocker',
  },
  {
    category: 'Gastrointestinal',
    name: 'Domperidone 10 mg tablet',
    adultDose: '10 mg PO TDS',
    pediatricDose: '0.3 mg/kg PO TDS',
    notes: 'Prokinetic/antiemetic',
  },
  {
    category: 'Gastrointestinal',
    name: 'Ondansetron 4 mg tablet',
    adultDose: '4 mg PO TDS',
    pediatricDose: '0.1 mg/kg PO TDS',
    notes: '5‑HT3 antagonist antiemetic',
  },
  {
    category: 'Gastrointestinal',
    name: 'Oral Rehydration Salts (ORS)',
    adultDose: 'As required',
    pediatricDose: 'As required',
    notes: 'Rehydration for diarrhea',
  },
  {
    category: 'Gastrointestinal',
    name: 'Loperamide 2 mg capsule',
    adultDose: '2 mg after each loose stool (max 8 mg/day)',
    pediatricDose: 'Not recommended under 12 years',
    notes: 'Antidiarrheal',
  },
  {
    category: 'Gastrointestinal',
    name: 'Dicyclomine 10 mg tablet',
    adultDose: '10 mg PO TID',
    pediatricDose: '5 mg PO TID',
    notes: 'Antispasmodic for colic',
  },
  {
    category: 'Gastrointestinal',
    name: 'Drotaverine 40 mg tablet',
    adultDose: '40 mg PO TID',
    pediatricDose: 'Not routinely used',
    notes: 'Smooth muscle relaxant for spasm',
  },

  // Musculoskeletal and pain
  {
    category: 'Musculoskeletal',
    name: 'Paracetamol 500 mg tablet',
    adultDose: '500–1000 mg PO QID (max 4 g/day)',
    pediatricDose: '15 mg/kg/dose PO QID',
    notes: 'Analgesic/antipyretic',
  },
  {
    category: 'Musculoskeletal',
    name: 'Ibuprofen 400 mg tablet',
    adultDose: '400 mg PO TID',
    pediatricDose: '10 mg/kg/dose PO TID',
    notes: 'NSAID analgesic',
  },
  {
    category: 'Musculoskeletal',
    name: 'Diclofenac 50 mg tablet',
    adultDose: '50 mg PO BD',
    pediatricDose: 'Not routinely used',
    notes: 'NSAID analgesic',
  },
  {
    category: 'Musculoskeletal',
    name: 'Naproxen 250 mg tablet',
    adultDose: '250 mg PO BD',
    pediatricDose: 'Not routinely used',
    notes: 'NSAID analgesic',
  },
  {
    category: 'Musculoskeletal',
    name: 'Etoricoxib 60 mg tablet',
    adultDose: '60 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Selective COX‑2 inhibitor',
  },
  {
    category: 'Musculoskeletal',
    name: 'Aceclofenac 100 mg tablet',
    adultDose: '100 mg PO BD',
    pediatricDose: 'Not routinely used',
    notes: 'NSAID analgesic',
  },
  {
    category: 'Musculoskeletal',
    name: 'Thiocolchicoside 8 mg tablet',
    adultDose: '8 mg PO BD',
    pediatricDose: 'Not recommended',
    notes: 'Skeletal muscle relaxant',
  },

  // Dermatology
  {
    category: 'Dermatology',
    name: 'Clotrimazole 1% cream',
    adultDose: 'Apply thin layer BD',
    pediatricDose: 'Apply thin layer BD',
    notes: 'Topical antifungal',
  },
  {
    category: 'Dermatology',
    name: 'Miconazole 2% cream',
    adultDose: 'Apply thin layer BD',
    pediatricDose: 'Apply thin layer BD',
    notes: 'Topical antifungal',
  },
  {
    category: 'Dermatology',
    name: 'Mupirocin 2% ointment',
    adultDose: 'Apply TDS',
    pediatricDose: 'Apply TDS',
    notes: 'Topical antibiotic',
  },
  {
    category: 'Dermatology',
    name: 'Betamethasone 0.05% cream',
    adultDose: 'Apply thin layer BD (short course)',
    pediatricDose: 'Apply thin layer BD (short course)',
    notes: 'Topical corticosteroid',
  },
  {
    category: 'Dermatology',
    name: 'Silver sulfadiazine 1% cream',
    adultDose: 'Apply to burns daily',
    pediatricDose: 'Apply to burns daily',
    notes: 'Burn wound dressing',
  },

  // Neurology and psychiatry
  {
    category: 'Neurology/Psychiatry',
    name: 'Phenytoin 100 mg tablet',
    adultDose: '100 mg PO TDS',
    pediatricDose: '5 mg/kg/day in divided doses',
    notes: 'Anticonvulsant',
  },
  {
    category: 'Neurology/Psychiatry',
    name: 'Valproic acid 250 mg tablet',
    adultDose: '250 mg PO TDS',
    pediatricDose: '10–15 mg/kg/day in divided doses',
    notes: 'Anticonvulsant/mood stabilizer',
  },
  {
    category: 'Neurology/Psychiatry',
    name: 'Diazepam 5 mg tablet',
    adultDose: '5 mg PO TID',
    pediatricDose: '0.05 mg/kg PO BID',
    notes: 'Anxiolytic/anticonvulsant',
  },
  {
    category: 'Neurology/Psychiatry',
    name: 'Haloperidol 5 mg tablet',
    adultDose: '5 mg PO BD',
    pediatricDose: '0.05 mg/kg/day in divided doses',
    notes: 'Antipsychotic',
  },
  {
    category: 'Neurology/Psychiatry',
    name: 'Amitriptyline 25 mg tablet',
    adultDose: '25 mg PO HS',
    pediatricDose: 'Not routinely used',
    notes: 'Tricyclic antidepressant',
  },
  {
    category: 'Neurology/Psychiatry',
    name: 'Sertraline 50 mg tablet',
    adultDose: '50 mg PO OD',
    pediatricDose: '0.5 mg/kg/day',
    notes: 'SSRI antidepressant',
  },

  // Pregnancy and lactation
  {
    category: 'Pregnancy',
    name: 'Folic acid 5 mg tablet',
    adultDose: '5 mg PO OD',
    pediatricDose: '5 mg PO OD',
    notes: 'Periconceptional supplementation',
  },
  {
    category: 'Pregnancy',
    name: 'Iron tablet (100 mg elemental iron)',
    adultDose: '100 mg PO OD',
    pediatricDose: 'Not applicable',
    notes: 'Prophylaxis and treatment of anemia',
  },
  {
    category: 'Pregnancy',
    name: 'Calcium + Vitamin D3 tablet',
    adultDose: 'One tablet PO BD',
    pediatricDose: 'Not applicable',
    notes: 'Supplement for pregnancy & lactation',
  },
  {
    category: 'Pregnancy',
    name: 'Levothyroxine 50 mcg tablet',
    adultDose: '50 mcg PO OD (adjust to TSH)',
    pediatricDose: 'Consult specialist',
    notes: 'Thyroid hormone replacement',
  },

  // Infectious diseases
  {
    category: 'Infectious',
    name: 'Amoxicillin 500 mg capsule',
    adultDose: '500 mg PO TDS',
    pediatricDose: '25–50 mg/kg/day in divided doses',
    notes: 'Amino‑penicillin antibiotic',
  },
  {
    category: 'Infectious',
    name: 'Azithromycin 500 mg tablet',
    adultDose: '500 mg PO OD × 3 days',
    pediatricDose: '10 mg/kg PO OD × 3 days',
    notes: 'Macrolide antibiotic',
  },
  {
    category: 'Infectious',
    name: 'Ciprofloxacin 500 mg tablet',
    adultDose: '500 mg PO BD',
    pediatricDose: 'Not recommended',
    notes: 'Fluoroquinolone antibiotic',
  },
  {
    category: 'Infectious',
    name: 'Doxycycline 100 mg capsule',
    adultDose: '100 mg PO BD',
    pediatricDose: 'Not recommended under 8 years',
    notes: 'Tetracycline antibiotic',
  },
  {
    category: 'Infectious',
    name: 'Metronidazole 400 mg tablet',
    adultDose: '400 mg PO TID',
    pediatricDose: '7.5 mg/kg PO TID',
    notes: 'Nitroimidazole antibiotic',
  },
  {
    category: 'Infectious',
    name: 'Co‑trimoxazole tablet (160/800 mg)',
    adultDose: '1 DS tablet PO BD',
    pediatricDose: 'Trimethoprim 4 mg/kg + sulfamethoxazole 20 mg/kg BD',
    notes: 'Sulfonamide combination antibiotic',
  },
  {
    category: 'Infectious',
    name: 'Cefixime 200 mg tablet',
    adultDose: '200 mg PO BD',
    pediatricDose: '8 mg/kg/day BD',
    notes: 'Third‑generation cephalosporin',
  },
  {
    category: 'Infectious',
    name: 'Fluconazole 150 mg tablet',
    adultDose: '150 mg PO stat',
    pediatricDose: '6 mg/kg PO OD',
    notes: 'Systemic antifungal',
  },

  // Non‑communicable diseases (metabolic, cardiovascular, etc.)
  {
    category: 'Non‑communicable',
    name: 'Metformin 500 mg tablet',
    adultDose: '500 mg PO BD with meals',
    pediatricDose: 'Not routinely used',
    notes: 'First‑line for type 2 diabetes',
  },
  {
    category: 'Non‑communicable',
    name: 'Gliclazide 80 mg tablet',
    adultDose: '80 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Sulfonylurea for type 2 diabetes',
  },
  {
    category: 'Non‑communicable',
    name: 'Teneligliptin 20 mg tablet',
    adultDose: '20 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'DPP‑4 inhibitor for type 2 diabetes',
  },
  {
    category: 'Non‑communicable',
    name: 'Insulin human regular',
    adultDose: 'Sliding scale as per chart',
    pediatricDose: 'Sliding scale as per chart',
    notes: 'Short‑acting insulin for glycemic control',
  },
  {
    category: 'Non‑communicable',
    name: 'Amlodipine 5 mg tablet',
    adultDose: '5 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Calcium channel blocker for hypertension',
  },
  {
    category: 'Non‑communicable',
    name: 'Losartan 50 mg tablet',
    adultDose: '50 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Angiotensin receptor blocker for hypertension',
  },
  {
    category: 'Non‑communicable',
    name: 'Hydrochlorothiazide 25 mg tablet',
    adultDose: '25 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Thiazide diuretic',
  },
  {
    category: 'Non‑communicable',
    name: 'Atenolol 50 mg tablet',
    adultDose: '50 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Selective beta‑blocker',
  },
  {
    category: 'Non‑communicable',
    name: 'Rosuvastatin 10 mg tablet',
    adultDose: '10 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Statin for dyslipidaemia',
  },
  {
    category: 'Non‑communicable',
    name: 'Clopidogrel 75 mg tablet',
    adultDose: '75 mg PO OD',
    pediatricDose: 'Not routinely used',
    notes: 'Antiplatelet agent',
  },

  // Paediatric formulations
  {
    category: 'Paediatric',
    name: 'Paracetamol syrup 125 mg/5 mL',
    adultDose: '15 mg/kg/dose QID',
    pediatricDose: '15 mg/kg/dose QID',
    notes: 'Antipyretic/analgesic for children',
  },
  {
    category: 'Paediatric',
    name: 'Amoxicillin syrup 125 mg/5 mL',
    adultDose: '25–50 mg/kg/day in divided doses',
    pediatricDose: '25–50 mg/kg/day in divided doses',
    notes: 'Antibiotic for paediatric infections',
  },
  {
    category: 'Paediatric',
    name: 'ORS (paediatric)',
    adultDose: 'As required',
    pediatricDose: 'As required',
    notes: 'Paediatric oral rehydration',
  },

  // Emergency & accidents
  {
    category: 'Emergency',
    name: 'Adrenaline injection 1 mg/mL',
    adultDose: '1 mg IV/IM in cardiac arrest',
    pediatricDose: '0.01 mg/kg IV/IM',
    notes: 'Resuscitation/anaaphylaxis',
  },
  {
    category: 'Emergency',
    name: 'Atropine injection 0.6 mg/mL',
    adultDose: '0.6 mg IV/IM repeated as needed',
    pediatricDose: '0.02 mg/kg IV/IM',
    notes: 'Bradycardia/poisonings',
  },
];

export default medicineList;